export const InfoBox = ({ title, children, type = 'info' }) => {
    const colours = {
        info: 'bg-blue-50 border-blue-200 text-blue-800',
        warning: 'bg-yellow-50 border-yellow-200 text-yellow-800',
        success: 'bg-green-50 border-green-200 text-green-800'
    };

    return (
        <div className={`rounded-lg border p-4 my-4 ${colours[type]}`}>
            {title && <div className="font-semibold mb-2">{title}</div>}
            <div className="text-sm">{children}</div>
        </div>
    );
};

export const MiniFormulaBox = ({ formula, description }) => (
    <div className="bg-gray-50 rounded-lg p-4 my-4">
        <div className="text-center font-mono text-sm sm:text-base mb-2 p-3 bg-white rounded border overflow-x-auto">
            {formula}
        </div>
        {description && <p className="text-xs sm:text-sm text-gray-600 text-center">{description}</p>}
    </div>
);
